import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { ApiService } from "src/app/services/api";
import { TimezoneService } from 'src/app/services/timezone';
import { Observable, of } from "rxjs";
import { shareReplay } from "rxjs/operators";


@Injectable({
  providedIn: "root"
})
export class OverallReportsService {
  GLOBALURL: String = this.ApiService.getBaseURL()
  headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
  httpOptions = { headers: new HttpHeaders(this.headerToken) };

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private ApiService: ApiService,
  ) {}

  getNetSalesReport(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number,
  ): Observable<any> {
    const params = {
      "reportName": "merchant_report",
      "query": {
          "metric": "sales",
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }

  getOrdersAndTransactions(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number,
  ): Observable<any> {
    const params = {
      "reportName": "merchant_report",
      "query": {
          "metric": "order_tranx_count",
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }

  getMetrics(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number,
  ): Observable<any> {
    const params = {
      "reportName": "merchant_report",
      "query": {
          "metric": "tip_tax_discount",
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }

  getTopProducts(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number,
  ): Observable<any> {
    const params = {
      "reportName": "top_product_report",
      "query": {
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }

  getSummaryReport(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number
  ): Observable<any> {
    const params = {
      "reportName": "merchant_summary_report",
      "query": {
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }

  getTopTransactions(
    merchantId: string | undefined | null,
    startDate: number,
    endDate: number,
  ): Observable<any> {
    const params = {
      "reportName": "top_transaction_report",
      "query": {
          "merchantId": merchantId,
          "startDate": startDate,
          "endDate": endDate,
      }
    }

    return this.http.post(this.GLOBALURL + '/reports/query', params, this.httpOptions).pipe(shareReplay(1))
  }
}
